<template>
  <main>
    <section class="banner"></section>
    <breadcrumb></breadcrumb>
    <section class="tab flex container">
      <a v-for="item in tab" :key="item.key" :href="item.path" :class="{'active':activeName===item.name}">{{item.name}}</a>
    </section>
    <router-view></router-view>
  </main>
</template>

<script>
export default {
  components: {},
  name: 'about',
  data() {
    return {
      tab: [
        { name: '公司介绍', key: 'company', path: '/about/company' },
        { name: '联系我们', key: 'contact', path: '/about/contact' },
      ],
      activeName: '公司介绍',
    }
  },
  methods: {
  },
  watch: {
    $route: {
      handler(val) {
        this.activeName = val.name
      },
      immediate: true,
    }
  },
}
</script>

<style lang='scss' scoped>
p {
  white-space: pre-line;
  font-size: 20px;
  color: #8e8e8e;
}
h3 {
  color: #262626;
}
main {
  background: #fbfbff;
}
.banner {
  height: 540px;
  background: url("/static/img/about/banner.png") center/cover;
}
.tab {
  height: 80px;
  margin-top: 39px;
  .active {
    background: #F66A27;
    color: #fff;
  }
  a {
    flex: 1;
    background: #f2f2f2;
    font-size: 24px;
    color: #262626;
    line-height: 80px;
    &:hover {
      opacity: 0.9;
    }
  }
}
</style>
